module.exports = __webpack_public_path__ + "media/components/src/assets/images/embellishments/book-details/slider_01-1d563711476622ac0034e15cdf241ab9.svg";